<template>
  <div class="home">
  </div>
</template>

<script>
import utils from '@/services/utils';

export default {
  name: 'home',
  created() {
    if (utils.isLogin()) {
      window.location.href = '/#/learning-center';
    } else {
      window.location.href = '/#/login';
    }
  },
};
</script>

<style lang="scss">
@import '@/styles/variables.scss';

</style>
